import {
  ParagraphLines,
} from "@/ui/components/primitives/Skeleton/ParagraphLines";
import type { FC } from "react";
import { AspectRatio, Skeleton } from "@/ui/components/primitives";
import { HorizontalRule, Stack } from "@/ui/components/layout";

export const ArticleCardSkeleton: FC = () => (
  <article
    data-component="ArticleCardSkeleton"
    className="flex h-full w-full flex-col overflow-hidden rounded-sys-sm border border-solid border-component-card-base shadow-sm"
  >
    <AspectRatio ratio="4:3" className="bg-state-loading" />
    <div className="flex flex-1 flex-col p-4">
      <Stack gap="2">
        <ParagraphLines />
        <ParagraphLines />
      </Stack>
      <div className="mt-auto pt-4">
        <HorizontalRule />
      </div>
      <div className="pt-4">
        <Skeleton className="w-full" />
      </div>
    </div>
  </article>
);
